/**
 * Copyright 2025 Google LLC. This software is provided as-is, without warranty 
 * or representation for any use or purpose. Your use of it is subject to your 
 * agreement with Google.
 */

import { Injectable, inject } from '@angular/core';
import { OKTA_AUTH } from '@okta/okta-angular';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private router: Router) { }
  private oktaAuth = inject(OKTA_AUTH);

  handleAuthState() {
    this.oktaAuth.authStateManager.subscribe((authState) => {
      if (!authState.isAuthenticated) {
        // Token expired or user logged out
        this.router.navigate(['/unauthorized']);
      }
    });
  }


}
